<template>
  <div class="flex">
    <div class="flex-1">
      <coupons-list ref="couponsListRef" />
    </div>
    <div style="width: 160px" class="ml-8">
      <vs-button @click="newCouponPopup = true">کد تخفیف جدید</vs-button>
    </div>
    <vs-popup title="کد تخفیف" :active.sync="newCouponPopup">
      <new-coupon @couponCreated="couponCreated" />
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CouponsList from "./CouponsList.vue";
import NewCoupon from "./NewCoupon.vue";

export default {
  name: "Coupons.vue",
  components: { CouponsList, NewCoupon },
  data() {
    return {
      newCouponPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    couponCreated(coupon) {
      this.$refs.couponsListRef.createCoupon(coupon);
      this.newCouponPopup = false;
    },
  },
};
</script>
